//axios
import axios from 'axios'

// const etat  = 'dev'
const etat  = 'prod'
// const etat  = 'prod-test'

// const ipDev = '192.168.0.100'
const ipDev = 'localhost'
const ipProd = 'back.esm.his-tech.tech'
const portDev = ':8050'
const portProd = ''
const httpsDev = 'http'
const httpsProd = 'https'
const wssDev = 'ws'
const wssProd = 'wss'

const esmWsIpDev = `${wssDev}://${ipDev}${portDev}/ws/chat/`
const esmWsIpProd = `${wssProd}://${ipProd}${portProd}/ws/chat/`

const baseURLDev = `${httpsDev}://${ipDev}${portDev}/api/`
const baseURLProd = `${httpsProd}://${ipProd}${portProd}/api/`

if (etat === 'dev') {
  localStorage.setItem('esm_ws_ip', esmWsIpDev)
  axios.defaults.baseURL = baseURLDev
} else if (etat === 'prod') {
  localStorage.setItem('esm_ws_ip', esmWsIpProd)
  axios.defaults.baseURL = baseURLProd
}

axios.defaults.headers.common['Authorization'] = String('jwt ') + localStorage.getItem('accessToken')

export default axios.create({
  // You can add your headers here
})

/*
channels==2.4.0
channels-redis==2.4.1 /home/prince/djangoprojects/histech-backend/esm-backend
*/